<div class="driver-view-container" *ngIf="profileView">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
  <div class="driver-view">
    <div class="heading">
      <h3>Driver Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="row m-0">
      <div class="col-sm-9">
        <div class="row mtb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Name</div>
            <div class="dec">{{ profileData?.username }}</div>
          </div>
          <div class="col-sm-7">
            <div class="dec">
              {{ profileData?.mobile }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
            <div class="dec">
              {{ profileData?.email }}
              <img src="../../../assets/img/tick-verify.svg" />
            </div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-8">
            <div class="head">Comapany Name</div>
            <div class="dec">{{ profileData?.company_name }}</div>
          </div>
          <div class="col-sm-4">
            <div class="head">GST</div>
            <div class="dec">{{ profileData?.gst }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div class="col-sm-5">
            <div class="head">Pan</div>
            <div class="dec">{{ profileData?.pan }}</div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div>
            <div class="head">Contact Details</div>
            <div class="dec">
              {{ profileData?.billing_address?.address_line }},{{
                profileData?.billing_address?.area_name
              }},{{ profileData?.billing_address?.city }},{{
                profileData?.billing_address?.state
              }},{{ profileData?.billing_address?.pincode }}
            </div>
          </div>
        </div>
        <div class="row mb mr-0 ml-0">
          <div>
            <div class="head">Mobile</div>
            <div class="dec">{{ profileData?.billing_address?.mobile }}</div>
          </div>
        </div>
      </div>

      <div class="col-sm-3">
        <div class="right-side">
          <img src="{{ profileImage }}" class="driverImg" />
          <div class="row mr-0 ml-0">
            <div class="col-sm-5 p-0">
              <div class="dec-head">Gender</div>
              <div class="dec-head">DOB</div>
            </div>
            <div class="col-sm-7 p-0">
              <div class="dec-right">{{ profileData?.gender }}</div>
              <div class="dec-right">
                {{ profileData?.dob | date : "MM/dd/yyyy" }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="head mb">Bank Details</div>
    <div class="row mb mr-0 ml-0">
      <div class="col-sm-6">
        <div class="head">Account Number</div>
        <div class="dec">
          {{ profileData?.account_details?.accountr_number }}
        </div>
      </div>
      <div class="col-sm-6">
        <div class="head">IFSC</div>
        <div class="dec">{{ profileData?.account_details?.ifsc_code }}</div>
      </div>
    </div>
    <div class="row mb mr-0 ml-0">
      <div class="col-sm-6">
        <div class="head">Account Name</div>
        <div class="dec">{{ profileData?.account_details?.account_name }}</div>
      </div>
      <div class="col-sm-6">
        <div class="head">Branch</div>
        <div class="dec">{{ profileData?.account_details?.branch_name }}</div>
      </div>
    </div>
    <div>
      <div class="head mb">Documents</div>
      <div class="row mb mr-0 ml-0">
        <div class="col-sm-4">
          <div class="head-b">Canelled Cheque</div>
        </div>
        <div class="col-sm-4">
          <div class="dec"></div>
        </div>
        <div class="col-sm-4">
          <div class="dec-view">
            <a href="{{ profileData?.cancelled_cheque }}">View</a>
          </div>
        </div>
      </div>
    </div>
    <div class="fixed-btn">
      <button (click)="editProfile()">Edit</button>
    </div>
  </div>
</div>

<div class="driver-view-container" *ngIf="profileEdit">
  <img
    src="../../../assets/img/icons8-macos-close-60.png"
    class="close-icons"
    (click)="close()"
  />
  <div class="driver-view">
    <div class="heading">
      <h3>Profile</h3>
    </div>
    <mat-divider></mat-divider>
    <div class="input-fileds-container category-edit">
      <form action="" [formGroup]="profileForm" class="admin-forms mt-3">
        <div class="row">
          <div class="col-md-9">
            <div class="row mtb">
              <div class="col-md-5">
                <div class="head">Name</div>
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      style="text-transform: capitalize"
                      formControlName="username"
                      required
                    />
                    <mat-error
                      *ngIf="(ProfileFormControl['username'].touched) && ProfileFormControl['username'].errors?.['required']"
                    >
                      Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['username'].touched) && ProfileFormControl['username'].errors?.['pattern']"
                    >
                      Please enter a valid name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      (keypress)="validateNumber($event)"
                      matInput
                      formControlName="mobile"
                      readonly
                      required
                    />

                    <div class="otp-field">
                      <img src="../../../assets/img/tick-verify.svg" />
                    </div>
                    <mat-error
                      *ngIf="(ProfileFormControl['mobile'].touched) && ProfileFormControl['mobile'].errors?.['required']"
                    >
                      Mobile is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['mobile'].touched) && ProfileFormControl['mobile'].errors?.['pattern']"
                    >
                      Please enter a valid mobile</mat-error
                    >
                  </mat-form-field>
                </div>
                <div class="mt-2 w-100 pull-left">
                  <mat-form-field>
                    <input matInput type="email" formControlName="email" />
                    <div class="otp-field">
                      <img src="../../../assets/img/error.svg" />
                    </div>
                    <div class="otp-field"></div>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5">
                <div class="">Company Name</div>
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="company_name" required />
                    <mat-error
                      *ngIf="(ProfileFormControl['company_name'].touched) && ProfileFormControl['company_name'].errors?.['required']"
                    >
                      Company Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['company_name'].touched) && ProfileFormControl['company_name'].errors?.['pattern']"
                    >
                      Please enter a Company Name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
              <div class="col-md-5">
                <div class="">GST</div>
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      toUppercase
                      appAlphanumericOnly
                      formControlName="gst"
                      required=""
                    />
                    <mat-error
                      *ngIf='ProfileFormControl["gst"].errors?.["required"]'
                    >
                      GST is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['gst'].touched) && ProfileFormControl['gst'].errors?.['pattern']"
                    >
                      Please enter GST</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5">
                <div class="">Pan</div>
                <div class="driver-truck">
                  <mat-form-field appearance="fill">
                    <input
                      matInput
                      toUppercase
                      appAlphanumericOnly
                      formControlName="pan"
                      required=""
                    />
                    <mat-error
                      *ngIf='ProfileFormControl["pan"].errors?.["required"]'
                    >
                      Pan is required</mat-error
                    >
                    <mat-error
                      *ngIf="(ProfileFormControl['pan'].touched) && ProfileFormControl['pan'].errors?.['pattern']"
                    >
                      Please enter Pan</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-3">
            <div class="right-img">
              <button (click)="uploadImage.click()">
                <img
                  src="{{ profileImage ? profileImage : '' }}"
                  class="driverImg"
                  style="height: 150px"
                />
                <div class="image-upload-area mt-3">
                  <span class="image">
                    <p>Add Profile Image</p>
                  </span>
                  <input
                    #uploadImage
                    type="file"
                    (change)="onChange($event)"
                    hidden
                  />
                </div>
              </button>
            </div>
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Gender</div>
              </div>
              <div class="col-md-8">
                <div class="driver-truck">
                  <mat-form-field appearance="fill">
                    <mat-select formControlName="gender">
                      <mat-option>Select Gender</mat-option>
                      <mat-option value="male">Male</mat-option>
                      <mat-option value="female">Female</mat-option>
                      <mat-option value="others">Others</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">DOB</div>
              </div>
              <div class="col-md-8">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      formControlName="dob"
                      [matDatepicker]="picker1"
                      [max]="today"
                      formControlName="dob"
                    />
                    <mat-datepicker-toggle
                      matSuffix
                      [for]="picker1"
                    ></mat-datepicker-toggle>
                    <mat-datepicker #picker1></mat-datepicker>
                    <mat-error
                      *ngIf='ProfileFormControl["dob"].touched && ProfileFormControl["dob"].errors?.["required"]'
                    >
                      Date of birth is required</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <form action="" [formGroup]="contactForm">
        <div class="row">
          <div class="col-md-9">
            <div class="heading">
              <h3>Contact Details</h3>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Name</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="username" required />
                    <mat-error
                      *ngIf="(contactFormControl['username'].touched) && contactFormControl['username'].errors?.['required']"
                    >
                      Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['username'].touched) && contactFormControl['username'].errors?.['pattern']"
                    >
                      Please enter a valid name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Address</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="address_line" required />
                    <mat-error
                      *ngIf="(contactFormControl['address_line'].touched) && contactFormControl['address_line'].errors?.['required']"
                    >
                      Address is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['address_line'].touched) && contactFormControl['address_line'].errors?.['pattern']"
                    >
                      Please enter a valid address</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Area</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="area_name" required />
                    <mat-error
                      *ngIf="(contactFormControl['area_name'].touched) && contactFormControl['area_name'].errors?.['required']"
                    >
                      Area name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['area_name'].touched) && contactFormControl['area_name'].errors?.['pattern']"
                    >
                      Please enter a valid area name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">City</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="city" required />
                    <mat-error
                      *ngIf="(contactFormControl['city'].touched) && contactFormControl['city'].errors?.['required']"
                    >
                      City is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['city'].touched) && contactFormControl['city'].errors?.['pattern']"
                    >
                      Please enter a valid city</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">State</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="state" required />
                    <mat-error
                      *ngIf="(contactFormControl['state'].touched) && contactFormControl['state'].errors?.['required']"
                    >
                      State is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['state'].touched) && contactFormControl['state'].errors?.['pattern']"
                    >
                      Please enter a valid state</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Pincode</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      (keypress)="validateNumber($event)"
                      formControlName="pincode"
                      minlength="6"
                      maxlength="6"
                      required
                    />
                    <mat-error
                      *ngIf="(contactFormControl['pincode'].touched) && contactFormControl['pincode'].errors?.['required']"
                    >
                      Pinode is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['pincode'].touched) && contactFormControl['pincode'].errors?.['pattern']"
                    >
                      Please enter a valid pincode</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Contact Number</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      (keypress)="validateNumber($event)"
                      matInput
                      formControlName="mobile"
                      maxlength="10"
                      minlength="10"
                      required
                    />
                    <mat-error
                      *ngIf="(contactFormControl['mobile'].touched) && contactFormControl['mobile'].errors?.['required']"
                    >
                      Mobile is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['mobile'].touched) && contactFormControl['mobile'].errors?.['pattern']"
                    >
                      Please enter a valid mobile</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">GST</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      toUppercase
                      appAlphanumericOnly
                      formControlName="gst"
                      required
                    />
                    <mat-error
                      *ngIf="(contactFormControl['gst'].touched) && contactFormControl['gst'].errors?.['required']"
                    >
                      gst number is required</mat-error
                    >
                    <mat-error
                      *ngIf="(contactFormControl['gst'].touched) && contactFormControl['gst'].errors?.['pattern']"
                    >
                      Please enter a valid gst number</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="heading">
        <h3>Bank Details</h3>
      </div>
      <form action="" [formGroup]="bankForm">
        <div class="row">
          <div class="col-sm-10">
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Account Name</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="account_name" required />
                    <mat-error
                      *ngIf="(bankFormControl['account_name'].touched) && bankFormControl['account_name'].errors?.['required']"
                    >
                      Account Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(bankFormControl['account_name'].touched) && bankFormControl['account_name '].errors?.['pattern']"
                    >
                      Please enter a valid account name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Account Number</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      type="number"
                      matInput
                      (keypress)="validateNumber($event)"
                      formControlName="accountr_number"
                      required
                    />
                    <mat-error
                      *ngIf="(bankFormControl['accountr_number'].touched) && bankFormControl['accountr_number'].errors?.['required']"
                    >
                      Account Number is required</mat-error
                    >
                    <mat-error
                      *ngIf="(bankFormControl['accountr_number'].touched) && bankFormControl['accountr_number '].errors?.['pattern']"
                    >
                      Please enter a valid account number</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">IFSC Code</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input
                      matInput
                      appAlphanumericOnly
                      toUppercase
                      formControlName="ifsc_code"
                      required
                    />
                    <mat-error
                      *ngIf="(bankFormControl['ifsc_code'].touched) && bankFormControl['ifsc_code'].errors?.['required']"
                    >
                      IFSC is required</mat-error
                    >
                    <mat-error
                      *ngIf="(bankFormControl['ifsc_code'].touched) && bankFormControl['ifsc_code'].errors?.['pattern']"
                    >
                      Please enter a valid IFSC</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Bank</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="bank_name" required />
                    <mat-error
                      *ngIf="(bankFormControl['bank_name'].touched) && bankFormControl['bank_name'].errors?.['required']"
                    >
                      Bank Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(bankFormControl['bank_name'].touched) && bankFormControl['bank_name'].errors?.['pattern']"
                    >
                      Please enter a valid bank name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
            <div class="row mtb">
              <div class="col-md-5 d-flex align-items-center">
                <div class="">Branch</div>
              </div>
              <div class="col-md-7">
                <div class="">
                  <mat-form-field>
                    <input matInput formControlName="branch_name" required />
                    <mat-error
                      *ngIf="(bankFormControl['branch_name'].touched) && bankFormControl['branch_name'].errors?.['required']"
                    >
                      Branch Name is required</mat-error
                    >
                    <mat-error
                      *ngIf="(bankFormControl['branch_name'].touched) && bankFormControl['branch_name'].errors?.['pattern']"
                    >
                      Please enter a valid branch name</mat-error
                    >
                  </mat-form-field>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>

      <form action="" [formGroup]="documentForm" class="admin-forms mt-3">
        <div class="heading">
          <h3>Documents</h3>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row mtb">
              <div class="col-md-4 d-flex align-items-center">
                <div class="">Cancelled Cheque</div>
              </div>
              <div
                class="col-md-4 d-flex align-items-center justify-content-center"
              >
                <div class="">
                  <span *ngIf="cancellationImageName"
                    >{{ cancellationImageName.substring(0, 5) + "..." }}
                    <img
                      src="../../../assets/img/cross.svg"
                      class="ms-2"
                      alt=""
                      (click)="cancelImage()"
                  /></span>
                  <div *ngIf="!cancellationImageName">
                    <a>
                      {{ cancelled_cheque }}
                    </a>
                  </div>
                  <span
                    class="image ms-3"
                    (click)="uploadCancellationImage.click()"
                    >Upload</span
                  >
                  <input
                    #uploadCancellationImage
                    type="file"
                    (click)="uploadCancellationImage.value = ''"
                    (change)="onChangeCancellation($event)"
                    hidden
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
      <div class="fixed-btn">
        <button
          [class.spinner]="loading"
          [disabled]="loading"
          (click)="updateProfile()"
        >
          save
        </button>
      </div>
    </div>
  </div>
</div>
